import api from '@/api';
import { API_BASE_URL } from '..';
import {
  CreateMoreThanOneInstallment,
  CreateOneInstallment,
  InstallmentMoreThanOneResponse,
  InstallmentOneResponse,
  UpdateOneInstallment,
} from './Installment.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function useGetInstallmentMoreThanOne(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/installments`,
    null,
  )) as unknown;
  return result as PageResult<InstallmentMoreThanOneResponse>;
}

export async function createOneInstallment(obj: CreateOneInstallment) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/installments`,
    values,
    null,
  )) as unknown;

  return result as InstallmentOneResponse;
}

export async function createMoreThanOneInstallment(
  obj: CreateMoreThanOneInstallment,
) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/installments/multiple`,
    values,
    null,
  )) as unknown;

  return result as InstallmentOneResponse;
}

export async function updateOneInstallment(obj: UpdateOneInstallment) {
  const { invoiceId, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/installments`,
    values,
    null,
  )) as unknown;

  return result as InstallmentOneResponse;
}

export async function getOneInstallment(obj: {
  invoiceId: number;
  id: number;
}) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${obj.invoiceId}/installments/${obj.id}`,
    null,
  )) as unknown;
  return result as InstallmentOneResponse;
}

export async function deleteOneInstallment(obj: {
  invoiceId: number;
  id: number;
}) {
  const result = await api.remove(
    `${CONTROLLER_URL}/${obj.invoiceId}/installments/${obj.id}`,
    {},
    null,
  );

  return result;
}
